import { SurveyQuestionType } from '../models/enums/SurveyQuestionType';
import Translator from '../core/i18n';

const T = Translator.create();

export const validateSurveyResponses = (surveyInfo: any, userResponses: any) => {
    let isError: boolean = false;

    const isResponseMissing = (id: any) => userResponses.findIndex((r: any) => r.surveyQuestionId === id) === -1;

    const isResponseEmptyAndMissing = (id: any) => {
        const response = userResponses.find((r: any) => r.surveyQuestionId === id);
        return !response || response.responseOpenEnded.trim() === "";
    };

    if (userResponses.length === 0 || !surveyInfo) {
        isError = true;
    }

    if (userResponses.length > 0 && surveyInfo?.questionList.length > 0) {
        try {
            surveyInfo.questionList.forEach((question: any) => {
                switch (question.questionType) {
                    case SurveyQuestionType.Matrix:
                        question.matrixQuestions?.forEach((matrixQuestion: any) => {
                            if (isResponseMissing(matrixQuestion.surveyQuestionId)) {
                                isError = true;
                            }
                        });
                        break;

                    case SurveyQuestionType.SingleChoice:
                    case SurveyQuestionType.MultipleChoice:
                        if (isResponseMissing(question.surveyQuestionId)) {
                            isError = true;
                        }
                        break;

                    case SurveyQuestionType.OpenEndedOneLine:
                    case SurveyQuestionType.OpenEndedTextArea:
                        if (isResponseEmptyAndMissing(question.surveyQuestionId)) {
                            isError = true;
                        }
                        break;

                    default:
                        break;
                }
            });
        } catch (e) {
            isError = true;
        }
    }

    return isError;
};